import type { RootState } from "@/services/store";

export const tokenSelector = (state: RootState) => state.auth.token;

export const refreshTokenSelector = (state: RootState) => state.auth.refreshToken;

export const runtimeTokenSelector = (state: RootState) => state.auth.runtimeToken;

export const appIsAuthenticatedSelector = (state: RootState) => state.auth.appIsAuthenticated;

export const selectAuthStatus = (state: RootState) => state.auth.authStatus;

export const enterPinErrorCountSelector = (state: RootState) => state.auth.enterPinErrorCount;

export const enterPinHasErrorSelector = (state: RootState) => state.auth.enterPinHasError;

export const shouldEnterPinSelector = (state: RootState) => state.auth.shouldEnterPin;

export const loginErrorSelector = (state: RootState) => state.auth.loginError;
